import * as React from 'react';

interface ToplistIconProps {
  color?: string;
  style?: React.CSSProperties;
  className?: string;
}

const ToplistIcon = ({ color = '#000', ...props }: ToplistIconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 140 140" width="1em" height="1em" {...props}>
    <g fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path
        d="M6.563 91.875h30.625v43.75H6.561zM102.813 109.375h30.624v26.25h-30.625zM54.688 74.375h30.624v61.25H54.689zM75.28 6.277l7.285 14.32h12.407a3.395 3.395 0 012.445 5.834L86.024 37.619l6.312 14.496a3.436 3.436 0 01-4.894 4.3l-15.255-8.582-15.254 8.581a3.436 3.436 0 01-4.894-4.299l6.294-14.496-11.375-11.212a3.395 3.395 0 012.445-5.833h12.43l7.286-14.32a3.465 3.465 0 016.16.023z"
        strokeWidth={8.749995}
      />
    </g>
  </svg>
);

export default ToplistIcon;
